export default "__VITE_ASSET__CifYiHzl__"